var lib_core     = require("lib-core");
var ui_templates = require("ui-templates");
var $            = require("jquery");
var _            = require("underscore");

var MasterView = function(model, statemachine, editorHolder, options){
    var self = this;
    this.options = options;
    this.model = model;
    this.statemachine = statemachine;
    this.editorHolder = editorHolder;

    // MENU
    // disable for view mode
    if(!this.options.noNav) this.getTopNav();

    if(_.isFunction(options.title)) {
        self.setTitle(options.title());
        options.title.onChange(this, function(value, old) {
            self.setTitle(value);
        });
    } else {
        self.setTitle(options.title);
    }

    // OBSERVE
    self.model.activeTab.onChange('activeTab', function(){
        self.model.tabs.forEach(function(idx, tab){
            if (tab.name() == self.model.activeTab()) {
                tab.getModel().setActive();
            } else {
                tab.getModel().setInactive();
            }
        });
    },10);
};

MasterView.prototype.getTemplate = function(){
    if(!this._template){
        this._template = ui_templates.LayoutCircuits($(this.editorHolder), this.options.noNav);
    }
    return this._template;
};

MasterView.prototype.getTopNav = function(){
    if(!this.cio_ui_topnav)
        this.cio_ui_topnav = this.getTemplate().addTopNav(this.options.logoLink, this.options.logoImage);
    return this.cio_ui_topnav;
};

MasterView.prototype.setTitle = function(title){
    //return in view mode
    if(this.options.noNav) return;

    var self = this;

    if(!this._title_template){
        this._title_template = this.cio_ui_topnav.addTitle(title, (this.options.readonly || false));
        this._title_template.setInActive();

        this.model.wizardMode.onChange(this, function(val) {
            if(!val) {
                self.attachEventListenerAndMakeTitleActive();
            }
        });

        if(!this.model.wizardMode()) {
            this.attachEventListenerAndMakeTitleActive();
        }
    } else{
        this._title_template.setTitle(title);
    }
};

//attach event listener to switch to settings tab on title click and set the title active to update the style of title on mouse hover
MasterView.prototype.attachEventListenerAndMakeTitleActive = function() {
    var self = this;

    self._title_template.setActive();

    self._title_template.$el.on('Cioui:TopNavTitle:clicked', function(e, val){
        var cEvent = new lib_core.GuiEvent();
        cEvent.type(lib_core.GuiEvents.SWITCH_TAB);
        cEvent.data("tab", "settings_tab");
        self.statemachine.handle(cEvent);
    });
};

module.exports = MasterView;
